<template>
  <div id="app">
    <div
      class="slide-type-image-bg"
      v-if="$store.state.slide.backgroundImage"
      id="slide-image-bg"
      :class="{'invisible': $store.state.presentation.privateMode}"
      :style="{
        'opacity': $store.state.slide.visibility / 100,
        'background-image': 'url(' + $store.state.slide.backgroundImage.large + ')',
      }"
    />

    <div class="slide-container">
      <router-view />

      <Reactions v-if="isReactionsVisible" />

      <span class="flex" />

      <Footer />
    </div>

    <div
      class="pswp"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <!-- Background of PhotoSwipe.
       It's a separate element as animating opacity is faster than rgba(). -->
      <div class="pswp__bg" />

      <!-- Slides wrapper with overflow:hidden. -->
      <div class="pswp__scroll-wrap">
        <!-- Container that holds slides.
          PhotoSwipe keeps only 3 of them in the DOM to save memory.
          Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
          <div class="pswp__item" />
          <div class="pswp__item" />
          <div class="pswp__item" />
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">
          <div class="pswp__top-bar">
            <!--  Controls are self-explanatory. Order can be changed. -->

            <div class="pswp__counter" />

            <button class="pswp__button pswp__button--close" title="Close (Esc)" />

            <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
            <!-- element will get class pswp__preloader--active when preloader is running -->
            <div class="pswp__preloader">
              <div class="pswp__preloader__icn">
                <div class="pswp__preloader__cut">
                  <div class="pswp__preloader__donut" />
                </div>
              </div>
            </div>
          </div>

          <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
            <div class="pswp__share-tooltip" />
          </div>

          <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" />

          <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)" />

          <div class="pswp__caption">
            <div class="pswp__caption__center" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// api
import Api from '@/api'

// utils
import Util from '@/util'

// components
import Footer from '@/components/footer/Footer.vue'
import Reactions from '@/components/reactions/Reactions.vue'

// containers
import FooterContainer from '@/containers/footer/Footer'
import ReactionsContainer from '@/containers/reactions/Reactions'

export default {
  components: {
    Footer: FooterContainer(Footer),
    Reactions: ReactionsContainer(Reactions),
  },
  data() {
    return {
      width: 668,
      iframeHeight: 375.75,
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      presentation: (state) => state.presentation,
    }),
    isReactionsVisible() {
      return !this.presentation.privateMode && this.slide.id
    },
  },
  watch: {
    '$store.state.slide': function handleSlideChanged(newData) {
      if (newData.id) {
        document.body.style.backgroundColor = newData.baseColour
        document.body.style.color = newData.textColour

        const qnaSessionBox = 'qna-session-box'

        if (document.getElementById(qnaSessionBox)) {
          document.getElementById(qnaSessionBox).style.backgroundColor = newData.baseColour
          document.getElementById(qnaSessionBox).style.color = newData.textColour
        }
      }
    },
    '$store.state.disableScrollBody': function handleDisableScrollBodyChanged(boolean) {
      if (boolean) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    },
    $route(refreshPage) {
      if (window.ga) {
        // do not track pageview when switching next/black slide (page with hash)
        // it will be manually sent in Presenter.view
        if (!refreshPage.hash) {
          window.ga('send', 'pageview', refreshPage.fullPath)
        }
      }
    },
  },
  mounted() {
    // setup vue resource in order to make AJAX requests
    Api.initResources()

    try {
      // FIXME: Consider removing this as there should be any reason why we need
      // a specific class for safari. This was added by Loi
      // to fix an issue with safari but we lost track of the original issue.
      // @huongnguyen2152 15.05.2020
      // eslint-disable-next-line
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      const ua = window.navigator.userAgent
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      const webkit = !!ua.match(/WebKit/i)
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      if (isSafari || iOSSafari) {
        document.body.classList.add('safari-env')
      }
    } catch (error) {
      // do notthing
    }
    if (Util.checkWhiteLabelDomain()) {
      Util.gaTrackEvent(
        'White Label',
        'Open White-Labelled Audience app',
        `Open White-Labelled Audience app at ${window.location.host}`,
      )
    }
  },
}
</script>

<style lang="scss">
.slide-type-image-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  &.invisible {
    visibility: hidden;
  }
}

.slide-container {
  min-height: 100%;
  display: flex;
  position: relative;
  z-index: 20;
  flex-direction: column;
}

.emoji-mart-preview {
  display: none !important;
}
</style>
